import {Box, CssBaseline, Typography} from "@mui/material";
import Sidebar from "../layout/Sidebar";
import Topbar from "../layout/Topbar";
import React from "react";
import {CustomMainRootBox} from "../dashboard/Dashboard";
import {styled} from "@mui/system";
import AutomationRules from "./AutomationRules";

const MainContainer = styled(Box)(({theme}) => ({
    height: "var(--app-height)",
    width: "100%",
    overflow: "auto",
    borderLeft: "1px solid " + theme.palette.background.tableBorder,
    paddingTop: "49px",
    [theme.breakpoints.down(600)]: {
        paddingTop: "49px",
    }
}));

function Automation({location, historyOnly = false, ...props}) {
    return (
        <CustomMainRootBox>
            <CssBaseline/>
            <Topbar/>
            <Sidebar {...props}/>
            <MainContainer>
                {historyOnly ? <Box sx={{p: 3}}><Typography variant="h5">Automation action logs</Typography></Box> : <AutomationRules/>}
            </MainContainer>
        </CustomMainRootBox>
    );
}

export default Automation;
